import { render, staticRenderFns } from "./ChroniclesPortrait.vue?vue&type=template&id=432b41ea&scoped=true"
import script from "./ChroniclesPortrait.vue?vue&type=script&lang=js"
export * from "./ChroniclesPortrait.vue?vue&type=script&lang=js"
import style0 from "./ChroniclesPortrait.vue?vue&type=style&index=0&id=432b41ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b41ea",
  null
  
)

export default component.exports